import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  loading: false,
  error: false,
  message: "",
  goldPrice: {},
};

const dashboardCurrentGoldPriceReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        message: "",
        loading: action.payload,
      };
    case TYPE.GET_CURRENT_GOLD_PRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Current Gold Price fetch successfully",
        goldPrice: action.payload.data,
      };
    case TYPE.GET_CURRENT_GOLD_PRICE_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching customer",
        goldPrice: {},
      };

    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default dashboardCurrentGoldPriceReducer;
